// https://github.com/mister-ben/videojs-seek-buttons
const { videojs } = window
const Button = videojs.getComponent('Button')
export const PLUGIN_NAME = 'SeekButtons'
const COMPONENT_NAME = 'SeekButton'

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you if not, remove the wait for "ready"!
 *
 * @function seekButtons
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
function seekButtons (options = {}) {
  // document.sbInit++
  this.ready(function onPlayerReady () {
    const player = this
    player.addClass('vjs-seek-buttons')
    const optionsMerged = videojs.mergeOptions({
      forwardIndex: 1,
      backIndex: 1,
    }, options)
    if (optionsMerged.forward && optionsMerged.forward > 0) {
      // eslint-disable-next-line no-param-reassign
      player.controlBar.seekForward = player.controlBar.addChild('seekButton', {
        direction: 'forward',
        seconds: optionsMerged.forward,
        seekForward: optionsMerged.seekForward,
      }, optionsMerged.forwardIndex)
    }

    if (optionsMerged.back && optionsMerged.back > 0) {
      // eslint-disable-next-line no-param-reassign
      player.controlBar.seekBack = player.controlBar.addChild('seekButton', {
        direction: 'back',
        seconds: optionsMerged.back,
        seekBack: optionsMerged.seekBack,
      }, optionsMerged.backIndex)
    }
  })
}

/**
 * Button to seek forward/back
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class SeekToggle
 */
class SeekButton extends Button {
  constructor (player, options) {
    super(player, options)
    if (this.options_.direction === 'forward') {
      this.controlText(
        this.localize(this.options_.seekForward),
      )
    } else if (this.options_.direction === 'back') {
      this.controlText(
        this.localize(this.options_.seekBack),
      )
    }
  }

  buildCSSClass () {
    /* Each button will have the classes:
       `vjs-seek-button`
       `skip-forward` or `skip-back`
       `skip-n` where `n` is the number of seconds
       So you could have a generic icon for "skip back" and a more
       specific one for "skip back 30 seconds"
    */
    const vjsClasses = 'vjs-control vjs-button'
    try {
      return `${vjsClasses} vjs-seek-button skip-${this.options_.direction} skip-${this.options_.seconds} ${super.buildCSSClass()}`
    } catch (_) {
      return `${vjsClasses} vjs-seek-button skip-${this.options_.direction} skip-${this.options_.seconds}`
    }
  }

  handleClick () {
    const now = this.player_.currentTime()

    if (this.options_.direction === 'forward') {
      this.player_.currentTime(now + this.options_.seconds)
    } else if (this.options_.direction === 'back') {
      this.player_.currentTime(now - this.options_.seconds)
    }
  }
}

export function register (videojsIn = window.videojs) {
  // console.log('register component with', videojs.VERSION, videojs)
  videojsIn.registerComponent(COMPONENT_NAME, SeekButton)
  // Register the plugin with video.js.
  registerPlugin(PLUGIN_NAME, seekButtons)
}
